export default __webpack_public_path__ + "static/HalvarBreit-XBd-423ff0a0ea64d4689895ee37e1f0a159.woff2";